import { ReactElement, useState } from "react";

import PageFooter from "global-components/pageFooter/PageFooter";
import RecoverUsernameForm from "./components/recoverUsernameForm/RecoverUsernameForm";
import Confirmation from "./components/confirmation/Confirmation";

import styles from "./recover-username.module.css";

const RecoverUsername = (): ReactElement => {
  const [submittedEmail, setSubmittedEmail] = useState<string | null>(null);

  return (
    <div className={styles.container}>
      <h1 className={styles.h1}>Recover your username</h1>

      <div>
        {submittedEmail ? (
          <Confirmation
            email={submittedEmail}
            onClickBack={() => setSubmittedEmail(null)}
          />
        ) : (
          <RecoverUsernameForm
            onComplete={(email) => setSubmittedEmail(email)}
          />
        )}
      </div>

      <PageFooter />
    </div>
  );
};

export default RecoverUsername;
